import { Component, Input } from '@angular/core';

/** Top-bar shortcut to the Tools page (Digital Signing, ...). */
@Component({
  selector: 'app-tools',
  templateUrl: './tools.component.html',
  standalone: false
})
export class ToolsComponent {
  @Input() isDropup = false;
  @Input() customStyle = 'btn btn-icon btn-custom btn-icon-muted btn-active-light btn-active-color-primary w-35px h-35px w-md-40px h-md-40px position-relative';
}
